document.addEventListener('DOMContentLoaded', () => {
  var switchRightSwiper = new Swiper('.unleash-switch .switch-right-container',{
    effect : 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    noSwiping: true,
    noSwipingClass: 'right-item',
  });
  var switchLeftSwiper = new Swiper(`.unleash-switch .switch-left-container`, {
    effect: 'cards',
    loop: true,
    navigation: {
      prevEl: '.mb-slick-prev',
      nextEl: '.mb-slick-next',
    },
    breakpoints: { 
      591: {
        navigation: {
          prevEl: '.pc-slick-prev',
          nextEl: '.pc-slick-next',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable :true,
        },
      }
    },
    pagination: {
      el: '.swiper-pagination',
      clickable :true,
    },
    controller: {
      control: switchRightSwiper,
    }
  });
});